// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconFlower = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path d="M14 12a2 2 0 11-4 0 2 2 0 014 0" />,
    <path
      fillRule="evenodd"
      d="M21.13 12a5.52 5.52 0 00-3.865-5.264 5.518 5.518 0 00-10.53 0 5.518 5.518 0 000 10.529 5.518 5.518 0 0010.53 0A5.52 5.52 0 0021.129 12M12 4.87a3.52 3.52 0 013.457 2.872l.125.676.677.125a3.518 3.518 0 010 6.914l-.677.126-.125.676a3.518 3.518 0 01-6.914 0l-.126-.676-.676-.126a3.518 3.518 0 010-6.914l.676-.125.126-.676A3.52 3.52 0 0112 4.87"
    />
  );
export default SvgIconFlower;
